require('./slider.js');
require('./backgroundColorBox.js');

Pegasus.BlockRegionSliderView = Pegasus.SliderView.extend({
  didInsertElement: function(){
    this._super();
    if ( this.get('showInput') ) {
      this.$('input').on('blur', function(){
        Em.run( this, 'mouseUp');
      }.bind(this));
    }
  },
  boundEvents: [
    'templateDecorationChanged',
    'themeChanged'
  ],

  templateDecorationChanged: function(){
    Em.run.scheduleOnce('afterRender', this, 'didChangeProperty');
  },

  themeChanged: function(){
    Em.run.scheduleOnce('afterRender', this, 'didChangeProperty');
  }
});

Pegasus.BlockRegionBorderView = Em.View.extend({
  content: function(){
    return Pegasus.blockRegionInstance;
  }.property('Pegasus.blockRegionInstance'),

  templateName: 'controls/block_region_border',

  borderWidthSlider: Pegasus.BlockRegionSliderView.extend({
    propertyReference: 'selectedBorderWidth',
    propertyBinding: 'controller.selectedBorderWidth',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 5
        }
      };
    }
  }),

  shadowBlurRadiusSlider: Pegasus.BlockRegionSliderView.extend({
    propertyReference: 'selectedShadowBlurRadius',
    propertyBinding: 'controller.selectedShadowBlurRadius',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 100
        }
      };
    }
  }),

  shadowSpreadRadiusSlider: Pegasus.BlockRegionSliderView.extend({
    propertyReference: 'selectedShadowSpreadRadius',
    propertyBinding: 'controller.selectedShadowSpreadRadius',
    showInput: true,
    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': -100,
          'max': 100
        }
      };
    }
  }),

  borderRadiusSlider: Pegasus.BlockRegionSliderView.extend({
    propertyReference: 'selectedBorderRadius',
    propertyBinding: 'controller.selectedBorderRadius',
    showInput: true,

    options: function(){
      return {
        start:[this.get('property')],
        range: {
          'min': 0,
          'max': 100
        }
      };
    }
  }),

  borderColorPickerView: Pegasus.BoundPropertyColorBoxView.extend({
    propertyName: 'controller.selectedBorderColor',
    property: function(){
      return this.get( this.get('propertyName') );
    }.property(),
    didInsertElement: function(){
      this._super();

      this.$('.ember-text-field').
        focus(function(){
          this.selectionStart = this.selectionEnd = this.value.length;
        }).
        off('keyup.' + this.get('elementId')).
        on('keyup.' + this.get('elementId'), function(e){
          this.onPickerChange( e.target.value );
          this.didBlur();
        }.bind(this));
    },
    onPickerChange: function(color){
      this._super.apply(this, arguments);
      this.set( this.get('propertyName'), this.get('property'));
      this.set('showColorReplacer', false);
    }
  })
});

Pegasus.BlockRegionSimpleBorderView = Pegasus.BlockRegionBorderView.extend({
  templateName: 'controls/block_region_simple_border',
});
